import { supabase } from "../utils/supabaseClient";

export const signInApi = async (email: string, password: string) => {
  return supabase.auth.signInWithPassword({ email, password });
};

export const signUpApi = async (email: string, password: string) => {
  return supabase.auth.signUp({ email, password });
};

export const signOutApi = async () => {
  return supabase.auth.signOut();
};

export const resetPasswordApi = async (email: string, redirectTo: string) => {
  return supabase.auth.resetPasswordForEmail(email, { redirectTo });
};
